<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <h1 class="title">Safari driver’s allowance</h1>
        <app-button
          v-if="is_general_manager || is_safari_supervisor"
          @click.native="onCalculateAllowance"
          size="small"
          ref="create"
        >
          Calculate
        </app-button>
      </app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__id><div class="table-default__left">#</div></template>
        <template #h__created><div class="table-default__left">Created by</div></template>
        <template #h__updated><div class="table-default__left">Updated by</div></template>
        <template #id="{ row }">
          <div class="table-default__left">
            <router-link
              :to="{ name: 'safari-allowance-detail', params: { id: row.id } }"
              class="table-default__link-border"
            >
              Allowance - {{ row.id }}
            </router-link>
          </div>
        </template>
        <template #month="{ row }">{{ dateFormat(row.month) }}</template>
        <template #status="{ row }">
          <span
            class="status-tag"
            :style="{ 'backgroundColor': row.status ? row.status.color : '#8a8a8a' }"
          >
              {{ row.status.name }}
            </span>
        </template>
        <template #days="{ row }">{{ row.days.toLocaleString() }}</template>
        <template #amount="{ row }">{{ row.amount.toLocaleString() }} TSh</template>
        <template #created="{ row }">
          <div class="table-default__left">
            <div v-if="row.created_by" class="table-default__controls">
              <div class="table-default__photo">
                <img
                  :src="getUserAvatar(row.created_by.crop.crop_url)" alt=""
                  v-tooltip="{ content: row.created_by.full_name, placement: 'top-start', offset: 10 }"
                >
              </div>
              {{ formatDateTime(row.created_at) }}
            </div>
          </div>
        </template>
        <template #updated="{ row }">
          <div class="table-default__left">
            <div v-if="row.updated_by" class="table-default__controls">
              <div class="table-default__photo">
                <img
                  :src="getUserAvatar(row.updated_by.crop.crop_url)" alt=""
                  v-tooltip="{ content: row.updated_by.full_name, placement: 'top-start', offset: 10 }"
                >
              </div>
              {{ formatDateTime(row.updated_at) }}
            </div>
          </div>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getEmployeesSafariDriverAllowanceList, postEmployeesSafariDriverAllowance } from '@/http'
import { format, parse, parseISO } from 'date-fns'

export default {
  name: 'SafariAllowanceList',
  data() {
    return {
      is_loaded: false,
      table_preloader: true,
      table: {
        items: [],
        columns: ['id', 'month', 'status', 'drivers', 'days', 'amount', 'created', 'updated'],
        options: {
          headings: {
            id: '#',
            month: 'Month',
            status: 'Status',
            drivers: 'Drivers',
            days: 'Days',
            amount: 'Amount',
            created: 'Created',
            updated: 'Updated',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      form: {},
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_safari_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('safari_supervisor')
    },
  },
  created() {
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      this.table_preloader = true
      getEmployeesSafariDriverAllowanceList({ page: this.pagination.page, page_size: 20 }).then(res => {
        this.table.items = res.data.results
        this.pagination.pages = res.data.pages
        this.pagination.count = res.data.count
        this.is_loaded = true
        this.table_preloader = false
      })
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    onCalculateAllowance() {
      this.$refs.create.preload = true
      postEmployeesSafariDriverAllowance()
        .then(res => {
          this.$router.push({ name: 'safari-allowance-detail', params: { id: res.data.id } })
        })
        .catch(() => { this.$refs.create.preload = false })
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'MMM yyyy')
    },
    formatDateTime(date) {
      if (!date) return ''
      return format(parseISO(date), 'dd MMMM yyyy HH:mm')
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>
